import React from 'react';
import { Dialog, Fade } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as Styles from './Styles';
import { Icon } from 'semantic-ui-react';
import { H5 } from 'utils/resuable-css';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 10px',
    outline: 0,
    zIndex: '999 !important',
  },
  hidden: {
    visibility: 'hidden',
  },
});
const CustomModal = ({ children, open, onClose, heading }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Dialog className={classes.modal} open={open} onClose={onClose}>
      <Fade in={open}>
        <Styles.ModalCross>
          <Styles.ModalHeading>
            <div className="heading">
              <Icon name="add" />
              <H5>{t(heading)}</H5>
            </div>
            <div className="modal_close">
              <Icon name="close" onClick={onClose} />
            </div>
          </Styles.ModalHeading>
          {children}
        </Styles.ModalCross>
      </Fade>
    </Dialog>
  );
};

export default CustomModal;
